global.antRouter = ''//全局的路由
global.appId='39f7cff8-d773-8d46-a740-c552e4165e54' //全局的应用Id